import { Prompt, ReducerAction, ReducerHandler } from '../../Types';
import { PaginationListType } from '../../Types/PaginationParams';
import { StoreEnvironment } from '../../Types/StoreTypes';
import {
    SET_BASE_PROMPT,
    SET_VISION_PROMPT,
    SET_SELECTED_PROMPT,
    SET_SHOW_USER_STATISTICS,
    SET_WINDOW_WIDTH,
    SET_WINDOW_BREAKPOINT,
    SET_DEMO_INSTANCE,
    SET_IS_CTRL_OR_CMD_PRESSED,
    SET_CURRENT_URL,
    SET_CURRENT_CHAT_ID,
    SET_COMBINED_PROMPTS,
    SET_IS_DRAG_ACTIVE,
    SET_DRAG_ZONE_ROOT_PROPS,
    SET_DRAG_ZONE_INPUT_PROPS,
    SET_SOURCE_CONTAINER_STATE,
    SET_USER_PROMPTS,
    SET_LIST_RELOAD_TYPE,
    SET_CHATLIST_CLEAR,
    SET_RELOAD_PROMPTS,
} from '../Actions/environmentActions';

const initialState = {
    basePrompt: {} as Prompt,
    userPrompts: [] as Prompt[],
    visionPrompt: '',
    selectedPrompt: '',
    showUserStatistics: false,
    windowWidth: window.innerWidth,
    windowBreakpoint: 1280,
    demoInstance: false,
    isCtrlOrCmdPressed: false,
    currentURL: '',
    currentChatId: '',
    combinedPrompts: [],
    isDragActive: false,
    dragZoneRootProps: () => {},
    dragZoneInputProps: () => {},
    sourceContainerState: false,
    listReloadType: null as PaginationListType | null,
    chatlistClear: false,
    reloadPrompts: false,
} as StoreEnvironment;

const environmentReducerMap: Record<string, ReducerHandler<StoreEnvironment>> = {
    [SET_BASE_PROMPT]: (state, action) => ({ ...state, basePrompt: action.payload }),
    [SET_VISION_PROMPT]: (state, action) => ({ ...state, visionPrompt: action.payload }),
    [SET_SELECTED_PROMPT]: (state, action) => ({ ...state, selectedPrompt: action.payload }),
    [SET_SHOW_USER_STATISTICS]: (state, action) => ({ ...state, showUserStatistics: action.payload }),
    [SET_WINDOW_WIDTH]: (state, action) => ({ ...state, windowWidth: action.payload }),
    [SET_WINDOW_BREAKPOINT]: (state, action) => ({ ...state, windowBreakpoint: action.payload }),
    [SET_DEMO_INSTANCE]: (state, action) => ({ ...state, demoInstance: action.payload }),
    [SET_IS_CTRL_OR_CMD_PRESSED]: (state, action) => ({ ...state, isCtrlOrCmdPressed: action.payload }),
    [SET_CURRENT_URL]: (state, action) => ({ ...state, currentURL: action.payload }),
    [SET_CURRENT_CHAT_ID]: (state, action) => ({ ...state, currentChatId: action.payload }),
    [SET_COMBINED_PROMPTS]: (state, action) => ({ ...state, combinedPrompts: action.payload }),
    [SET_IS_DRAG_ACTIVE]: (state, action) => ({ ...state, isDragActive: action.payload }),
    [SET_DRAG_ZONE_ROOT_PROPS]: (state, action) => ({ ...state, dragZoneRootProps: action.payload }),
    [SET_DRAG_ZONE_INPUT_PROPS]: (state, action) => ({ ...state, dragZoneInputProps: action.payload }),
    [SET_SOURCE_CONTAINER_STATE]: (state, action) => ({ ...state, sourceContainerState: action.payload }),
    [SET_USER_PROMPTS]: (state, action) => ({ ...state, userPrompts: action.payload }),
    [SET_LIST_RELOAD_TYPE]: (state, action) => ({ ...state, listReloadType: action.payload }),
    [SET_CHATLIST_CLEAR]: (state, action) => ({ ...state, chatlistClear: action.payload }),
    [SET_RELOAD_PROMPTS]: (state, action) => ({ ...state, reloadPrompts: action.payload }),
};

function environmentReducer(state = initialState, action: ReducerAction): StoreEnvironment {
    const handler = environmentReducerMap[action.type];
    return handler ? handler(state, action) : state;
}

export default environmentReducer;
